import { useMoney } from "../lib/CurrencyProvider";

export function Price({ price, priceArs, compareAt }: { price: number; priceArs?: number | null; compareAt?: number | null }) {
  const { format: formatPrice } = useMoney();
  // Catalog products TCGplayer has no price for (price 0) show no price instead of $0.
  if (price <= 0 && !priceArs) return null;
  const onSale = compareAt != null && compareAt > price;
  return (
    <span className="price">
      <span className={onSale ? "price-now is-sale" : "price-now"}>{formatPrice(price, priceArs)}</span>
      {onSale && <s className="price-was">{formatPrice(compareAt)}</s>}
    </span>
  );
}
